export default {"src":"/_next/static/media/history-image.1fdfff68.svg","height":627,"width":1560,"blurWidth":0,"blurHeight":0};